/* @flow */
import React, { useContext, memo } from 'react'
import S from './Text2.styled'
import { validation } from './Text2.consts'
import ActionGetter from './Actions'
import { DispatchContext, EditingContext } from '@contexts'
import Show from '@website/common/components/Show/Show'
import EditableContent from '@website/common/components/EditableContent'

const Text2 = memo(
  ({
    data: {
      title,
      paragraph,
      titleAlignment,
      paragraphAlignment,
      backgroundImgUrl,
      backgroundImgDimensions,
      bgOverlayTransparency
    }
  }) => {
    const { isEditing } = useContext(EditingContext)
    const dispatcher = useContext(DispatchContext)
    const Actions = ActionGetter(dispatcher)

    return (
      <Show when={[title, paragraph]}>
        <S.StyledContainer
          isEditing={isEditing}
          backgroundImgUrl={backgroundImgUrl}
          backgroundImgDimensions={backgroundImgDimensions}
          bgOverlayTransparency={bgOverlayTransparency}
        >
          <S.WMCustomContainer>
            <EditableContent
              text={title}
              alignment={titleAlignment}
              as={S.Title}
              maxCount={validation.maxTitleChar}
              className="WM_GLOBAL_heading"
              onChange={Actions.changeTitle}
              changeAlignment={Actions.changeTitleAlignment}
            />
            <EditableContent
              text={paragraph}
              alignment={paragraphAlignment}
              as={S.Description}
              maxCount={validation.maxParagraphChar}
              className="WM_GLOBAL_paragraph"
              onChange={Actions.changeParagraph}
              changeAlignment={Actions.changeParagraphAlignment}
            />
          </S.WMCustomContainer>
        </S.StyledContainer>
      </Show>
    )
  }
)

export default Text2
